import { Component } from '@angular/core';


@Component({
    selector: 'xform-404',
    templateUrl: './page-not-found.component.html',
    styleUrls: ['./page-not-found.component.scss'],
    standalone: false
})
export class PageNotFoundComponent {}
